const reportApiList = {
  billList: '/manage/order/order/reconciliationStatement', // 对账报表
  exportAccountData: '/manage/order/order/downloadAccount', // 导出对账
  accountlist: '/manage/order/order/accountlist', // 获取对账报表列表
  accountfilter: '/manage/order/order/accountfilter', // 对账报表筛选条件
  getReportCollectTotal: '/v2/web/shop/getReportCollectTotal', // 获取报表的总数据
  getReportCollectList: '/v2/web/shop/getReportCollectList', // 获取报表的列表数据
  getReportCollectInfo: '/v2/web/shop/getReportCollectInfo', // 获取报表的详情数据
  getReportCollectDetail: '/v2/web/shop/getReportCollectDetail' // 获取详情
}
export default reportApiList



// WEBPACK FOOTER //
// ./src/service/basic/reportApiList.js